var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"logo"}},[_c('a',{attrs:{"href":"https://www.pari.go.jp/","target":"_blank"}},[_c('img',{attrs:{"border":"0","src":_vm.pari_icon_path,"width":"32","height":"32","alt":"ロゴ"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }